export default __webpack_public_path__ + "static/media/Investment type_ Cow@1x.664e3dfa.png";